<template>
    <div
        :id="'category-' + data.id"
        :data-category-id="data.id"
        class="position-relative transition-all"
    >
        <v-tooltip right color="#e9f5f4" class="border-radius-2 border-color-primary">
            <template v-slot:activator="{ on, attrs }">
                <div
                    class="category-box d-flex flex-column justify-center align-center transition-all position-relative"
                    :data-category-id="data.id"
                    @click="setActiveCategories"
                    v-bind="attrs"
                    v-on="on"
                >
                    <div class="category-image" :id="'cat-' + data.id">
                        <img
                            :src="
                                'https://assets.beereaders.com/beauty_categories/' +
                                data.id +
                                '.svg'
                            "
                            @load="handleLoad"
                            class="category-img transition-all"
                            alt="Cat"
                        />
                        <v-skeleton-loader
                            v-if="!loaded"
                            class="position-absolute mb-9 opacity-none grey lighten-1"
                            height="60"
                            width="80"
                            type="image"
                            :transition="'scale-transition'"
                        ></v-skeleton-loader>
                        <span class="category-name">{{ data.name }}</span>
                    </div>
                    <div
                        class="pa-0 ma-0 position-absolute check transition-all"
                    >
                        <v-icon class="green--text transition-all white rounded-circle "
                            >mdi-checkbox-marked-circle</v-icon
                        >
                    </div>
                </div>
            </template>
            <v-row class="category-info border-color-blue">
                <v-col class="d-flex justify-center flex-column">
                    <span class="black--text text-short">{{ data.description }}</span>
                </v-col>
            </v-row>
        </v-tooltip>
    </div>
</template>

<script>
export default {
    props: {
        data: {},
        selected: { type: Boolean, default: false },
    },
    data() {
        return {
            info: false,
            loaded: false,
        }
    },
    mounted() {
        if (this.selected) {
            this.setActiveCategories()
        }
    },
    methods: {
        setActiveCategories() {
            const el = document.querySelector(`#category-${this.data.id}`)
            el.classList.toggle('category-active')
        },
        handleLoad() {
            this.loaded = true
        },
    },
}
</script>
<style>
.category-box {
    border-radius: 15px;
    box-shadow: -0.5vh 0.5px 5px 0px #cac4c4, inset -0.5px -0.5px 1px #d4d4d4;
    width: 15.5vh;
    height: 17.5vh;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    padding: 3vh;
    border: 1px #e8e8e8;
    border-style: hidden;
}

.category-image {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
}

.category-name {
    font-family: 'Patua One', cursive !important;
    color: #514773;
    font-size: 12px;
    line-height: 15px;
    margin-top: 3vh;
}
.border-color-blue {
    border-color: #514773;
}
.check {
    display: none;
}

.category-active .check {
    display: block !important;
    bottom: -2vh;
    right: -2vh;
}

.category-info:before {
    content: '';
    position: absolute;
    top: 10px;
    left: -20px;
    height: 10px;
    width: 20px;
    transform-origin: bottom left;
    z-index: -1;
    border-top: 30px solid transparent;
    border-right: 70px solid #e4f4f2;
    border-bottom: 30px solid transparent;
}

.text-short {
    max-width: 200px;
    font-size: 12px;
}
</style>
